// Deprecated file. Will be removed in some future major version.
export { default as default } from './PhoneInputReactResponsiveUIDefaultMetadata'